import { render, staticRenderFns } from "./PageDaySkeleton.vue?vue&type=template&id=355dbb40&scoped=true"
import script from "./PageDaySkeleton.vue?vue&type=script&lang=js"
export * from "./PageDaySkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageDaySkeleton.vue?vue&type=style&index=0&id=355dbb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355dbb40",
  null
  
)

export default component.exports